import { FC } from 'react';
import { ContactPc } from './ContactPc/ContactPc';

export const ContactPcPage: FC = () => {
  return <ContactPc />;
};
